const axios = require('axios');

/**
 * AjaxItem Function
 * @param {string} elementID - ID of the HTML element.
 * @param {object} customParams - Custom params for every request.
 * @param {object} customConfig - Custom config for AjaxItem.
 * @param {string} path - Path for Ajax requests (default is 'list').
 *
 * Note: Requires the library axios (https://github.com/axios/axios) to be installed.
 */
window.AjaxItemV2 = function(elementID, customParams, customConfig, path = 'list') {
  // check if elementID is a string
  if (typeof elementID !== 'string') {
    return;
  }

  const self = this;

  // request path
  let ajaxPath = (path !== '' ? path + '/' : '');

  // custom params for every request
  customParams = customParams || {};

  // default settings
  const defaults = {
    container: '#' + elementID,
    ajaxFile: BASE_PATH + 'ajax/' + ajaxPath + elementID.replace('js--', ''),
    callback: function() {
      // default empty callback function
    },
  };

  // check if params is an object
  if (typeof customConfig !== 'object') {
    customConfig = {};
  }

  let config = Object.assign({}, defaults, customConfig);

  /**
   * Sort items by a specific parameter
   * @param {string} sortByParam - The parameter to sort by.
   */
  this.sortBy = function(sortByParam) {
    self.updater({
      sortby: sortByParam,
    });
  };

  /**
   * [GET] Load data
   */
  this.loader = function() {
    // show loader
    self.showLoader();

    // GET request
    axios.get(config.ajaxFile, {
      params: {
        ...customParams,
        ajax: 1,
      },
    }).then(function(response) {
      window.executeInnerHTML(document.querySelector(config.container), response.data);
      self.afterLoad();
    }).catch(function(error) {
      window.executeInnerHTML(document.querySelector(config.container), error.response.data);
      console.error('Error: ', error.message);
    });
  };

  /**
   * [GET] Update data
   * @param {object} getParams - Parameters for updating data.
   */
  this.updater = function(getParams) {
    // show loader
    self.showLoader();

    // GET request
    axios.get(config.ajaxFile, {
      params: {
        ...typeof getParams !== 'undefined' ? getParams : {},
        ...customParams,
        ajax: 1,
      },
    }).then(function(response) {
      window.executeInnerHTML(document.querySelector(config.container), response.data);
      self.afterLoad();
    }).catch(function(error) {
      window.executeInnerHTML(document.querySelector(config.container), error.response.data);
      console.error('Error: ', error.message);
    });
  };

  /**
   * [POST] Send data
   * @param {object} postParams - Data to be sent.
   */
  this.poster = function(postParams) {
    // show loader
    self.showLoader();

    // POST request
    axios.post(config.ajaxFile, window.object2FormData({
      ...typeof postParams !== 'undefined' ? postParams : {},
      ...customParams,
      ajax: 1,
    })).then(function(response) {
      window.executeInnerHTML(document.querySelector(config.container), response.data);
      self.afterLoad();
    }).catch(function(error) {
      window.executeInnerHTML(document.querySelector(config.container), error.response.data);
      console.error('Error: ', error.message);
    });
  };

  /**
   * Actions to be performed after data is loaded
   */
  this.afterLoad = function() {
    if (typeof config.callback === 'function') {
      config.callback();
    }

    initLocationActions();
    initTooltip();
    _calculateScrollbarWidth();
    iOSInputFix();
  };

  /**
   * Display loader
   */
  this.showLoader = function() {
    window.autoLoader(config.container);
  };
};

/**
 * Object to form data
 * @param obj
 * @param formData
 * @returns {FormData}
 */
window.object2FormData = function(obj, formData = new FormData()) {
  this.formData = formData;

  this.createFormData = function(obj, subKeyStr = '') {
    for (let i in obj) {
      let value = obj[i];
      let subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i;

      if (typeof (value) === 'string' || typeof (value) === 'number') {
        this.formData.append(subKeyStrTrans, value);
      } else if (typeof (value) === 'object') {
        this.createFormData(value, subKeyStrTrans);
      }
    }
  };

  this.createFormData(obj);

  return this.formData;
};

/**
 * Execute innerHTML
 * @param element
 * @param html
 * @param append
 */
window.executeInnerHTML = function(element, html, append = false) {
  if (append === true) {
    element.innerHTML += html;
  } else {
    element.innerHTML = html;
  }

  // execute <script>
  const scriptTags = element.getElementsByTagName('script');
  for (let i = 0; i < scriptTags.length; i++) {
    const scriptCode = scriptTags[i].textContent || scriptTags[i].innerText;
    const executeScript = new Function(scriptCode);
    executeScript();
  }
};

/**
 * Insert loader
 * @param {string | HTMLElement} into
 * @param remove
 */
window.autoLoader = function(into = 'body', remove = false) {
  if (remove === true) {
    const ajaxLoader = document.querySelector('.ajax-loader');
    if (ajaxLoader) {
      ajaxLoader.remove();
    }
  } else {
    const container = typeof into === 'string' ? document.querySelector(into) : into;
    if (container && !container.querySelector('.ajax-loader')) {
      container.style.position = 'relative';
      container.style.minHeight = '100px';

      const ajaxLoaderDiv = document.createElement('div');
      ajaxLoaderDiv.className = 'ajax-loader';
      ajaxLoaderDiv.innerHTML = '<div class="loader">Loading...</div>';

      document.querySelector(into).appendChild(ajaxLoaderDiv);
    }
  }
};

window.autoLoaderV2 = function(into = 'body', remove = false) {
  const container = typeof into === 'string' ? document.querySelector(into) : into;
  if (container) {
    if (remove === true) {
      const ajaxLoader = container.querySelector('.ajax-loader');
      if (ajaxLoader) {
        ajaxLoader.remove();
      }
    } else if (!container.querySelector('.ajax-loader')) {
      container.style.position = 'relative';
      container.style.minHeight = '100px';

      const ajaxLoaderDiv = document.createElement('div');
      ajaxLoaderDiv.className = 'ajax-loader';
      ajaxLoaderDiv.innerHTML = '<div class="loader">Loading...</div>';

      document.querySelector(into).appendChild(ajaxLoaderDiv);
    }
  }
};

/**
 * Implementiert Event Bubbling für Elemente mit einer bestimmten Klasse oder per ID.
 *
 * @param selectorOrElement - Der CSS-Selektor (Klasse oder ID), nach dem gesucht werden soll.
 * @param {string} eventName - Der Name des abzufangenden Ereignisses (z.B. "click").
 * @param {Function} callback - Die Callback-Funktion, die aufgerufen wird, wenn das Ereignis ausgelöst wird.
 * @param {Document} [context=document] - Das Kontext-Element, in dem die Suche durchgeführt werden soll (Standardwert ist das gesamte Dokument).
 * @returns {Function} - Eine Funktion zum Entfernen des Event-Listeners.
 */
window.bubbleEvent = function(selectorOrElement, eventName, callback, context = document) {
  /**
   * Event-Handler für das abgefangene Ereignis.
   *
   * @param {Event} event - Das ausgelöste Ereignis.
   */
  function eventHandler(event) {
    let target = event.target;

    // Durchlaufe die Elemente in der Hierarchie, bis das Kontext-Element erreicht ist.
    while (target && target !== context) {
      if (typeof selectorOrElement === 'string') {
        if (target.matches(selectorOrElement)) {
          // Rufe die Callback-Funktion im Kontext des Ziel-Elements auf.
          callback.call(target, event);
        }
      } else {
        if (target === selectorOrElement) {
          // Rufe die Callback-Funktion im Kontext des Ziel-Elements auf.
          callback.call(target, event);
        }
      }
      target = target.parentElement;
    }
  }

  // Füge den Event-Listener dem Kontext-Element hinzu.
  context.addEventListener(eventName, eventHandler);

  // Gib eine Funktion zurück, um den Event-Listener später zu entfernen.
  return function() {
    context.removeEventListener(eventName, eventHandler);
  };
};

/**
 * Initialize location actions
 */
window.initLocationActions = function() {
  // Click open ajax dialog
  const openDialogElements = document.querySelectorAll('[data-open-dialog]');
  if (openDialogElements.length > 0) {
    openDialogElements.forEach(element => {
      if (!element.hasAttribute('data-init-action')) {
        element.addEventListener('click', function(e) {
          // Überprüfen, ob das geklickte Element oder eines seiner Elternteile die Klasse 'no-click' hat
          if (e.target.closest('.no-click')) {
            return;
          }

          e.preventDefault();

          let jsonObject = {};
          if (this.getAttribute('data-json-object')) {
            jsonObject = JSON.parse(this.getAttribute('data-json-object'));
          }

          const maxWidth = parseInt(this.getAttribute('data-maxwidth')) || 742;

          if (this.getAttribute('data-close-dialog-before')) {
            ajaxDialog('close');
          }

          ajaxDialog(this.getAttribute('data-open-dialog'), maxWidth, jsonObject);
          return false;
        });
        element.setAttribute('data-init-action', 'true');
      }
    });
  }
};

/**
 * is IOS
 * @returns {boolean}
 */
window.isIOS = function() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

/**
 * isIOS
 */
window.iOSInputFix = function() {
  if (isIOS()) {
    var dateInputs = document.querySelectorAll('input[type="date"]');
    dateInputs.forEach(function(input) {
      input.classList.add('ios-date');
    });

    var timeInputs = document.querySelectorAll('input[type="time"]');
    timeInputs.forEach(function(input) {
      input.classList.add('ios-date');
    });
  }
};

/**
 * statistic video
 */
window.statisticVideo = function() {
  document.querySelectorAll('video').forEach(function(video) {
    let firstPlay = true;

    video.addEventListener('play', function() {
      if (firstPlay) {
        firstPlay = false;

        axios.post(MP_PATH + 'ajax/helper/additional/statisticVideo', window.object2FormData({
          videoId: video.getAttribute('data-id'),
          videoStarted: true,
        })).then(function(response) {
        }).catch(function(error) {
          console.error('Axios call failed.', error);
        });
      }
    });
  });
};
